import { atom } from 'jotai';

/** Set to true while a step has a request in progress; blocks the "Siguiente" button. */
export const blockNextAtom = atom(false);
